'use client';
import { useCallback } from 'react';

import { useSession } from '~hooks/useSession';
import {
	useLazyGetRegistrationPropsQuery,
	useUpdateRegistrationPropsMutation,
} from '~services/api/user/endpoints';

export const useEmailConfirmationWallLocation = () => {
	const { userId } = useSession();
	const [getRegistrationProps] = useLazyGetRegistrationPropsQuery();
	const [trigger] = useUpdateRegistrationPropsMutation();

	const saveLocation = useCallback(
		(location?: string) => {
			void trigger({
				userId,
				location,
			});
		},
		[trigger, userId]
	);

	return { saveLocation, getLocation: getRegistrationProps };
};
